import { createApiSlice } from "@common";
import { CRUD_SEPARATION_TYPE } from "@routes";

const apiConfig = [
  {
    name: "addSeparationType",
    method: "post",
    url: CRUD_SEPARATION_TYPE,
    stateKey: "message"
  },
  {
    name: "getSeparationType",
    method: "get",
    url: CRUD_SEPARATION_TYPE,
    stateKey: "data"
  },
  {
    name: "updateSeparationType",
    method: "put",
    url: CRUD_SEPARATION_TYPE,
    stateKey: "message"
  },
  {
    name: "deleteSeparationType",
    method: "delete",
    url: CRUD_SEPARATION_TYPE,
    stateKey: "message"
  },
];

const customReducers = {
  initialState: {
    data: [],
    additionalData: []
  },
  reducers: {
    setAdditionalData:
      (state, action) => {
        state.additionalData = action.payload;
      },
  },
  extraReducers: {},
};

const { slice, thunks, actions } =
  createApiSlice("SeparationType", apiConfig, customReducers);
const SeparationTypeSlice = slice;

export default SeparationTypeSlice.reducer;

export const {
  addSeparationType,
  getSeparationType,
  updateSeparationType,
  deleteSeparationType
} = thunks;
export const {
  rowSelect
} = actions;
